export default "__VITE_ASSET__mLW46r5w__"